import { Link } from 'react-router-dom';

// react-bootstrap
import Image from 'react-bootstrap/Image';

// project-import
import { APP_DEFAULT_PATH } from 'config';

// assets
import logo from 'assets/images/user/10.png';


export const DrawerHeader = () => {
  return (
    <div className="m-header">
      <Link to={APP_DEFAULT_PATH} className="b-brand text-primary">
        <Image src={logo} alt="logo" style={{ width: '50px', height: '50px' }} className="logo logo-lg" />
      <span className="brand-name text-white ms-2">EBC SMS System</span>
      </Link>
    </div>
  );
};
